<script>
    import BgRelationModalView from '@/components/BgRelationModalView'

    export default {
        components: {
            BgRelationModalView: BgRelationModalView,
        },

        props: {
            show: {
                type: Boolean,
                required: true,
            },
            files: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                visible: false,
                selectedFile: 0,
            }
        },

        watch: {
            show: function (newValue) {
                this.visible = newValue
            },
        },

        methods: {}
    }
</script>

<template>
    <b-modal @close="$emit('close')" :active.sync="visible" has-modal-card custom-class="bg-upload__modal">
        <div class="card">
            <div class="card-content">
                <div class="columns bg-upload__grid" v-if="files.length == 1">
                    <div class="column">
                        <bg-relation-modal-view @search="value => $emit('search', value)" :file="files[0]"/>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
